import React, { useEffect, useState } from 'react';
import { makeStyles } from 'utils/makeStylesAdapter';
import { Card, Typography, Grid, Button, IconButton, Paper } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DescriptionIcon from '@mui/icons-material/Description';
import Tooltip from '@mui/material/Tooltip';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import ModalAddFile from 'components/IntimationNew/components/ModalAddFile';
import ModalListFiles from 'components/IntimationNew/components/ModalListFiles';
import { CERTIFICATE_TYPES } from 'constants/investigated-certificate-types';
import TimelineIcon from '@mui/icons-material/Timeline';
import ModalHistoryIntimation from 'components/ModalHistoryIntimation';

const useStyles = makeStyles(theme => ({
  root: {
    background: '#fff',
    borderRadius: 10,
    padding: 16,
  },
  dropzone: {
    height: '100%',
    width: '100%',
    border: '1px dashed #292929',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: 10,
    cursor: 'pointer',
  },
  inputMaterial: {
    width: '100%',
  },
  inputIntimation: {
    height: 35,
    width: '100%',
    marginTop: 10,
    backgroundColor: '#ededed',
    border: 0,
    padding: 5,
    borderRadius: 15,
    outline: 'none',
  },
  labelIntimation: {
    color: '#ffffff',
    fontSize: 14,
  },
  labelIntimationStatus: {
    color: '#ededed',
    fontSize: 16,
    fontWeight: 'bold',
    backgroundColor: '#00b1ac',
    padding: '10px',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    width: '100%',
    textAlign: 'center',
    boxSizing: 'border-box',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '46px',
  },
  labelIntimationModes: {
    marginLeft: 4,
    color: '#000000',
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: 4,
    padding: '10px',
    width: '100%',
    textAlign: 'left',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  labelIntimationContato: {
    backgroundColor: '#004a61',
    color: '#ffffff',
    fontSize: 12,
    fontWeight: 'bold',
    borderRadius: 15,
    padding: '2px 10px',
    marginLeft: 5,
    marginRight: 5,
    display: 'inline-block',
  },
  containerTituloRight: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
  },
  containerFather: {
    marginBottom: theme.spacing(1),
    backgroundColor: '#ededed',
    borderRadius: 10,
  },
  victimName: {
    display: 'inline-block',
    maxWidth: '220px',
    verticalAlign: 'bottom',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  containerContent: {
    minHeight: '135px',
  },
  historyButton: {
    background: 'white',
    borderRadius: '50%',
  }
}));

const HandleIntimationMonitoring = props => {
  const [openModalAddFile, setOpenModalAddFile] = useState(false);
  const [openModalListFile, setOpenModalListFile] = useState(false);
  const [selectedIntimation, setSelectedIntimation] = useState(null);

  const { intimations, inquiry, getIntimations } = props;

  const INTIMATION_TYPES = [
    { key: 'Investigado', label: 'Investigado' },
    { key: 'Delegado', label: 'Delegado' },
  ];

  const classes = useStyles();

  const permissionsReducer = useSelector(state => state.logedUser.permissions);
  const { write } = permissionsReducer.inquiriesIntimacao;

  const [openHistoryIntimationModal, setOpenHistoryIntimationModal] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedVictim, setSelectedVictim] = useState(null);

  const handleOpenSnackbar = (message = 'Você não tem permissão para tomar esta ação.') => {
    return toast.warn(message);
  };

  const handleCloseModalAddFile = () => {
    setOpenModalAddFile(false);
  };

  const handleCloseModalListFile = () => {
    setOpenModalListFile(false);
  };

  const getIntimationByType = typeKey => {
    return intimations.find(intimation => intimation.recipient === typeKey && intimation.isCurrent);
  };

  const getVictimIntimations = victimId => {
    return intimations.filter(
      intimation => intimation.recipient === 'Vítima' && intimation.victim?.id === victimId,
    );
  };

  const canAttachFile = intimation => {
    if (!intimation) return false;
    return !!intimation.attempts.find(
      attempt => attempt.mode === 'MANUAL' && attempt.status === 'AWAITING_RESPONSE',
    );
  };

  const handleOpenModalHistoryIntimation = (type, victim = null) => {
    setSelectedType(type);
    setSelectedVictim(victim);
    setOpenHistoryIntimationModal(true);
  };

  const handleCloseModalHistoryIntimation = () => {
    setOpenHistoryIntimationModal(false);
    setTimeout(() => {
      setSelectedVictim(null);
      setSelectedType(null);
    }, 300);
  };

  return (
    <div style={{ width: '100%' }}>
      <Grid container spacing={2} alignItems="stretch">
        {INTIMATION_TYPES.map(({ key, label }) => {
          const intimation = getIntimationByType(key);
          const hasIntimation = !!intimation;
          return (
            <Grid
              key={key}
              style={{ height: '100%' }}
              size={{
                xs: 12,
                sm: 6,
                md: inquiry?.inquiry?.victims?.length ? 4 : 6,
                lg: inquiry?.inquiry?.victims?.length ? 4 : 6,
                xl: inquiry?.inquiry?.victims?.length ? 4 : 6
              }}>
              <Paper className={classes.containerFather} style={{ padding: 0, height: '100%' }}>
                <Typography className={classes.labelIntimationStatus}>
                  {intimation?.status === 'AWAITING_RESPONSE'
                    ? 'Aguardando envio da intimação'
                    : intimation?.status === 'CANCELED'
                    ? 'Intimação não executada'
                    : intimation?.status === 'FAILED'
                    ? 'Intimação não executada'
                    : intimation?.status === 'SUCCESS'
                    ? 'Intimação realizada com sucesso'
                    : 'Não intimado'}
                  <Tooltip arrow placement="top" title="Ver histórico">
                    <span className={classes.historyButton}>
                      <IconButton
                        size="small"
                        onClick={() => {
                          handleOpenModalHistoryIntimation(
                            key,
                            intimation.victim,
                          );
                        }}
                      >
                        <TimelineIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Typography>
                <Grid container spacing={2} style={{ padding: 16 }}>
                  <Grid className={classes.containerContent} size={12}>
                    <Typography className={classes.labelIntimationModes}>
                      Tipo: <span style={{ fontWeight: 'normal' }}>{label}</span>
                    </Typography>
                    <Typography className={classes.labelIntimationModes}>
                      Meio de contato:
                      {hasIntimation && intimation.attempts?.length > 0 ? (
                        intimation.attempts.map(({ mode }, i) => (
                          <Typography key={i} className={classes.labelIntimationContato}>
                            {mode}
                          </Typography>
                        ))
                      ) : (
                        <Typography className={classes.labelIntimationContato}>
                          Sem meios de intimação
                        </Typography>
                      )}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                      alignItems: 'center',
                      marginTop: 10,
                    }}
                    size={12}>
                    <Tooltip
                      title={
                        !hasIntimation
                          ? 'Necessário intimação'
                          : canAttachFile(intimation)
                          ? 'Anexar intimação'
                          : intimation.status === 'SUCCESS'
                          ? 'Não é possível anexar após sucesso'
                          : intimation.status === 'CANCELED'
                          ? 'Não é possível anexar após cancelamento'
                          : 'Somente é possível anexar em intimações manuais'
                      }
                      arrow
                      placement="top"
                    >
                      <span>
                        <IconButton
                          onClick={() =>
                            write
                              ? (setSelectedIntimation(intimation), setOpenModalAddFile(true))
                              : handleOpenSnackbar()
                          }
                          style={{
                            backgroundColor: canAttachFile(intimation) ? '#00b1ac' : '#d7d7d7',
                          }}
                          disabled={!canAttachFile(intimation)}
                        >
                          <AttachFileIcon fontSize="large" style={{ color: '#ededed' }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Ver arquivo anexado" arrow placement="top">
                      <IconButton
                        onClick={() => (
                          setSelectedIntimation(intimation), setOpenModalListFile(true)
                        )}
                        style={{ backgroundColor: hasIntimation ? '#00b1ac' : '#d7d7d7' }}
                        disabled={!hasIntimation}
                      >
                        <DescriptionIcon fontSize="large" style={{ color: '#ededed' }} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          );
        })}
        {inquiry?.inquiry?.victims?.length > 0 &&
          inquiry?.inquiry?.victims.map(victim => {
            const victimIntimations = getVictimIntimations(victim.id);
            const currentIntimation =
              victimIntimations.find(i => i.isCurrent) ||
              (victimIntimations.length > 0
                ? victimIntimations[victimIntimations.length - 1]
                : null);
            const hasIntimation = !!currentIntimation;
            return (
              <Grid
                key={victim.id}
                style={{ height: '100%' }}
                size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                <Paper className={classes.containerFather} style={{ padding: 0, height: '100%' }}>
                  <Typography className={classes.labelIntimationStatus}>
                    {currentIntimation?.status === 'AWAITING_RESPONSE'
                      ? 'Aguardando resposta da intimação'
                      : currentIntimation?.status === 'CANCELED'
                      ? 'Intimação não executada'
                      : currentIntimation?.status === 'FAILED'
                      ? 'Intimação não executada'
                      : currentIntimation?.status === 'SUCCESS'
                      ? 'Intimação realizada com sucesso'
                      : 'Não intimado'}
                    <Tooltip arrow placement="top" title="Ver histórico">
                      <span className={classes.historyButton}>
                        <IconButton
                          size="small"
                          onClick={() => {
                            handleOpenModalHistoryIntimation(
                              CERTIFICATE_TYPES.VITIMA,
                              currentIntimation.victim,
                            );
                          }}
                        >
                          <TimelineIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Typography>
                  <Grid container spacing={2} style={{ padding: 16 }}>
                    <Grid className={classes.containerContent} size={12}>
                      <Typography className={classes.labelIntimationModes}>
                        Tipo:{' '}
                        <span className={classes.victimName} style={{ fontWeight: 'normal' }}>
                          Vítima - {victim.name || victim.nome}
                        </span>
                      </Typography>
                      <Typography className={classes.labelIntimationModes}>
                        Meio de contato:
                        {hasIntimation && currentIntimation.attempts?.length > 0 ? (
                          currentIntimation.attempts.map(({ mode }, i) => (
                            <Typography key={i} className={classes.labelIntimationContato}>
                              {mode}
                            </Typography>
                          ))
                        ) : (
                          <Typography className={classes.labelIntimationContato}>
                            Sem meios de intimação
                          </Typography>
                        )}
                      </Typography>
                    </Grid>
                    <Grid
                      container
                      style={{
                        display: 'flex',
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        marginTop: 10,
                      }}
                      size={12}>
                      <Tooltip
                        title={
                          !hasIntimation
                            ? 'Necessário intimação'
                            : canAttachFile(currentIntimation)
                            ? 'Anexar intimação'
                            : currentIntimation.status === 'SUCCESS'
                            ? 'Não é possível anexar após sucesso'
                            : currentIntimation.status === 'CANCELED'
                            ? 'Não é possível anexar após cancelamento'
                            : 'Somente é possível anexar em intimações manuais'
                        }
                        arrow
                        placement="top"
                      >
                        <span>
                          <IconButton
                            onClick={() =>
                              write
                                ? (setSelectedIntimation(currentIntimation),
                                  setOpenModalAddFile(true))
                                : handleOpenSnackbar()
                            }
                            style={{
                              backgroundColor: canAttachFile(currentIntimation)
                                ? '#00b1ac'
                                : '#d7d7d7',
                            }}
                            disabled={!canAttachFile(currentIntimation)}
                          >
                            <AttachFileIcon fontSize="large" style={{ color: '#ededed' }} />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="Ver arquivo anexado" arrow placement="top">
                        <IconButton
                          onClick={() => (
                            setSelectedIntimation(currentIntimation), setOpenModalListFile(true)
                          )}
                          style={{ backgroundColor: hasIntimation ? '#00b1ac' : '#d7d7d7' }}
                          disabled={!hasIntimation}
                        >
                          <DescriptionIcon fontSize="large" style={{ color: '#ededed' }} />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            );
          })}
      </Grid>
      {intimations.length > 0 && (
        <ModalAddFile
          open={openModalAddFile}
          onClose={handleCloseModalAddFile}
          intimation={selectedIntimation}
          getIntimations={getIntimations}
        />
      )}
      {openModalListFile && (
        <ModalListFiles
          open={openModalListFile}
          onClose={handleCloseModalListFile}
          intimation={selectedIntimation}
        />
      )}
      {intimations?.length > 0 && (
        <ModalHistoryIntimation
          open={openHistoryIntimationModal}
          onClose={handleCloseModalHistoryIntimation}
          intimations={
            selectedType === CERTIFICATE_TYPES.VITIMA && selectedVictim
              ? intimations.filter(
                  intimation =>
                    intimation.recipient === CERTIFICATE_TYPES.VITIMA &&
                    intimation.victim?.id === selectedVictim.id,
                )
              : intimations.filter(intimation => intimation.recipient === selectedType)
          }
          selectedType={selectedType}
          victim={selectedVictim}
        />
      )}
    </div>
  );
};
export default HandleIntimationMonitoring;
